const SIGN_TEMPLATES = [
  {
    id: "simple",
    name: "Simple",
    background: "#FFFFFF",
    textColor: "#111111",
    accentColor: "#111111",
    eyebrow: "SHARE THE MOMENTS",
    headline: "Scan to Share",
    instruction: "Scan the QR code to add your photos",
    fontFamily: "Arial, Helvetica, sans-serif",
    headlineFontFamily: "Arial, Helvetica, sans-serif",
  },

  {
    id: "dark",
    name: "After Dark",
    background: "#101010",
    textColor: "#FFFFFF",
    accentColor: "#FFFFFF",
    eyebrow: "DON'T MISS A MOMENT",
    headline: "Share the Night",
    instruction: "Scan to add your photos",
    fontFamily: "Arial, Helvetica, sans-serif",
    headlineFontFamily: "Arial, Helvetica, sans-serif",
    dark: true,
  },

  {
    id: "cowprint",
    name: "Cow Print",
    background: "#FFF8EA",
    textColor: "#4A2C1A",
    accentColor: "#6A4026",
    eyebrow: "CAPTURE THE MOMENTS",
    headline: "Share Your Photos",
    instruction: "Scan to add your photos",
    fontFamily: "Arial, Helvetica, sans-serif",
    headlineFontFamily: "Georgia, 'Times New Roman', serif",
    pattern: "cowprint",
  },

  {
    id: "editorial",
    name: "Editorial",
    background: "#F6F1E8",
    textColor: "#171717",
    accentColor: "#171717",
    eyebrow: "THE EVENT",
    headline: "Share Your Photos",
    instruction: "Scan to add your favorite moments",
    fontFamily: "Georgia, 'Times New Roman', serif",
    headlineFontFamily: "Georgia, 'Times New Roman', serif",
  },

  {
    id: "romantic",
    name: "Romantic",
    background: "#FFF8F6",
    textColor: "#342824",
    accentColor: "#B89286",
    eyebrow: "CAPTURED WITH LOVE",
    headline: "Share the Love",
    instruction: "Scan to share your photos with us",
    fontFamily: "Georgia, 'Times New Roman', serif",
    headlineFontFamily: "Georgia, 'Times New Roman', serif",
  },

  {
    id: "modern",
    name: "Modern",
    background: "#F1F1F1",
    textColor: "#000000",
    accentColor: "#000000",
    eyebrow: "ONE EVENT. EVERY ANGLE.",
    headline: "Your Photos\nBelong Here",
    instruction: "Scan. Upload. Done.",
    fontFamily: "Arial, Helvetica, sans-serif",
    headlineFontFamily: "Arial, Helvetica, sans-serif",
  },

  {
    id: "party",
    name: "Party",
    background: "#F2EDFF",
    textColor: "#18131F",
    accentColor: "#6A48FF",
    eyebrow: "YOU WERE THERE",
    headline: "Drop Your Pics",
    instruction: "Scan the QR code and share the moments",
    fontFamily: "Arial, Helvetica, sans-serif",
    headlineFontFamily: "Arial, Helvetica, sans-serif",
  },

  {
    id: "minimal",
    name: "Minimal",
    background: "#FAFAF8",
    textColor: "#1A1A1A",
    accentColor: "#1A1A1A",
    eyebrow: "SHARED CAMERA",
    headline: "Every Perspective",
    instruction: "Scan to share what you captured",
    fontFamily: "Georgia, 'Times New Roman', serif",
    headlineFontFamily: "Georgia, 'Times New Roman', serif",
  },
];

export default SIGN_TEMPLATES;